import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  DeleteWarehouseOperationTypeActions as Actions,
  DeleteWarehouseOperationTypeRequestAction as RequestAction,
} from 'store/ducks/warehouseOperationTypes';

export function* deleteWarehouseOperationTypeRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.delete, `warehouse-operation-types/${id}`);
    onSuccess && onSuccess();
    notify('success', 'Regra desvinculada com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
